@if (isVisible) {
<div @fadeSlide class="alert" [ngClass]="type">
  <mat-icon class="icon">{{ getIconName(type) }}</mat-icon>
  <div class="content">
    @if (label) {
    <div class="label">{{ label }}</div>
    } @if (!isObjectMessage()) {
    <div class="message" [innerHTML]="message"></div>
    } @else {
    <div class="message">
      @for (item of messageEntries; track item) {
      <div>
        <strong>{{ item.key }}:</strong> {{ item.value }}
      </div>
      }
    </div>
    }
  </div>
  <div class="actions">
    @if (ctaLabel) {
    <button mat-stroked-button color="primary" (click)="onCtaClick()">
      {{ ctaLabel }}
    </button>
    } @if (dismissible) {
    <button mat-icon-button (click)="onDismiss()">
      <mat-icon>close</mat-icon>
    </button>
    }
  </div>
</div>
}
